import { setError } from "redux/errors/errorActions";
import { api } from "_endpoints/api";
import http from "../../axios";

export const SEND_TICKET_EMAIL_REQUEST = "SEND_TICKET_EMAIL_REQUEST";
export const SEND_TICKET_EMAIL_SUCCESS = "SEND_TICKET_EMAIL_SUCCESS";
export const SEND_TICKET_EMAIL_FAIL = "SEND_TICKET_EMAIL_FAIL";

export const GET_TICKET_QUOTES_REQUEST = "GET_TICKET_QUOTES_REQUEST";
export const GET_TICKET_QUOTES_SUCCESS = "GET_TICKET_QUOTES_SUCCESS";
export const GET_TICKET_QUOTES_FAIL = "GET_TICKET_QUOTES_FAIL";

export const sendTicketEmail = (emailData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: SEND_TICKET_EMAIL_REQUEST });
      const response = await http.post(api.tickets.sendTicketEmail(), emailData);
      dispatch({ type: SEND_TICKET_EMAIL_SUCCESS, payload: response.data });
      dispatch(setError([{ msg: "Email sent successfully!", isOpen: true, duration: 6000, severity: "success" }]));
      return { success: true };
    } catch (error) {
      dispatch({ type: SEND_TICKET_EMAIL_FAIL, error: error.response?.data?.message || "Failed to send email" });
      dispatch(
        setError([
          { msg: error.response?.data?.message || "Failed to send email. Please try again.", isOpen: true, duration: 6000, severity: "error" }
        ])
      );
      return { success: false, message: error.response?.data?.message || "An error occurred" };
    }
  };
};

export const getTicketQuotes = (ticketId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_TICKET_QUOTES_REQUEST });
      const response = await http.get(api.tickets.getTicketQuotes(ticketId));
      if (response.data.status) {
        dispatch({ type: GET_TICKET_QUOTES_SUCCESS, payload: response.data.quotes || [] });
      } else {
        throw new Error(response.data.message || "Failed to fetch quotes");
      }
    } catch (error) {
      dispatch({ type: GET_TICKET_QUOTES_FAIL, error: error.response?.data?.message || "Failed to fetch quotes" });
      dispatch(
        setError([
          {
            msg: error.response?.data?.message || "Failed to fetch quotes. Please try again.",
            isOpen: true,
            duration: 6000,
            severity: "error"
          }
        ])
      );
    }
  };
};
